/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React  from 'react';
// material
import { Button, Tip } from '@insticator/insticator-ui';
import Space from 'material/space/space';
// content
// styles
import injectSheet from 'react-jss'
import styles from './actionbuttons_styles'


/* ========== ~~~~~~~~~~ MODERATION CONFIG V2: GENERAL SECTION ~~~~~~~~~~ ========== */
const ActionButtons = injectSheet(styles)((props) => {
  const { hideSetLive, onSaveDraft, onSetCurrent, saveDraftDisabled, setAsCurrentDisabled, saveDraftText } = props;

  return (
    <Space justifyContent={'flex-end'} alignItems={'center'} klass={`productgroupactions ${props.classes.productgroupactions}`}>
      {/* <Button variant={'primary'} name={'savedraft'} text={saveDraftText} handleClick={onSaveDraft} disabled={saveDraftDisabled} /> */}
      { !hideSetLive &&
        <Button variant={'none'} color={'compliment'} name={'setascurrent'} text={'Set Live'} handleClick={onSetCurrent} disabled={setAsCurrentDisabled} />
      }
      {/* <Tip 
        space={'none'} 
        icon={'question-circle'} 
        content={`
          This will replace your "Current" settings with your "Draft" settings and 
          publish the changes live on your website for all users to see.
        `} 
        label={''} 
      /> */}
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ActionButtons;